module.exports = __webpack_public_path__ + "11_mustache_brown.9b3be559.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer3/11_mustache_brown.png
// module id = 4xCI
// module chunks = 0